import { generateContext } from '@btime/react-contexts'
import React, { useContext, useMemo, useState } from 'react'
import * as mime from 'mime-types'

import { useTransformDocumentOnList } from '../../../utils/hooks/transformDocument'
import { isDocumentImage } from '@btime/helpers'

const { StateContext, ActionsContext, Provider } = generateContext()
export const useGalleryState = () => useContext(StateContext)
export const useGalleryActions = () => useContext(ActionsContext)

const GalleryHandler = ({ items, onRemove, onChange, ...props }) => {
  const [selected, setSelected] = useState(false)

  const onClose = () => setSelected(false)

  const getFileType = item => {
    const src = item.src || item.fileSrc || item.document?.fileSrc
    return src !== undefined ? mime.lookup(src)?.split('/')[0] : item
  }

  const options = useMemo(
    () =>
      (items || [])
        .filter(i => i !== null && Object.keys(i).length)
        .map((item, index) => ({
          origin: item,
          type: getFileType(item),
          isImage: isDocumentImage(item),
          value: item.src || item.fileSrc || item.document?.fileSrc,
          label: item.description,
          index
        })),
    [items]
  )

  const [onTransform, { loading }] = useTransformDocumentOnList(items, (list, newDoc) => {
    onChange(list)
    setSelected(newDoc)
  })

  const handleTransform = transform => e => {
    onTransform(selected, transform)
  }

  const handleRemove = (item, index) => e => {
    if (!!e && e.stopPropagation) e.stopPropagation()
    onRemove(item, index)
  }

  const moveImage = count => {
    if (!selected) return false
    let index = selected.index + count
    const lastIndex = options.length - 1
    if (index > lastIndex) {
      index = 0
    } else if (index < 0) {
      index = lastIndex
    }

    setSelected(options[index])
  }

  const goToNextImage = () => moveImage(1)
  const goToPrevImage = () => moveImage(-1)

  return (
    <Provider
      state={{ selected, images: items, canRemove: !!onRemove, options, loading }}
      actions={{ goToNextImage, goToPrevImage, moveImage, handleRemove, setSelected, onClose, handleTransform }}
      {...props}
    />
  )
}

export default GalleryHandler
